const toCompletedInput = (completed) =>
  (completed ?? []).map(({ type, value }) => ({ type, value }));

/**
 * Sparse `ProjectAcceptanceReportDataInput` of one card: the values of `fieldNames` (direct
 * fields of `enpalReport`, e.g. `existingDamageNotes`) plus the card states `completed`. Photos
 * and signatures have their own mutations (see feature page projekt-protokolle).
 */
export const toAcceptanceCardInput = (enpalReport, fieldNames) => ({
  ...Object.fromEntries(
    fieldNames.map((fieldName) => [fieldName, enpalReport?.[fieldName] ?? null])
  ),
  completed: toCompletedInput(enpalReport?.completed),
});
